module.exports = __webpack_public_path__ + "img/APEX-logo-U2.b29d6e12.jpg";